import IContaPagamentoContraCteResponseDTO from '../entities/IContaPagamentoContraCteResponseDTO'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IContaPagamentoContraCte {
  execute(frotistaId: number): Promise<IContaPagamentoContraCteResponseDTO>
}

export default class ContaPagamentoContraCteImpl
  implements IContaPagamentoContraCte
{
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  async execute(
    frotistaId: number,
  ): Promise<IContaPagamentoContraCteResponseDTO> {
    const response = await this.pagamentoRepository.contaPagamentoContraCte(
      frotistaId,
    )
    return response
  }
}
